import { combineReducers } from 'redux';
import menu from './menu';
import snackbar from './snackbar';
import { airflowApi } from 'store/airflow/airflowSlice';
import jobscriptEditSliceReducer from '../additional/applications/customHPCJobs/jobScriptEdit';
import inputDatasetPathReducer from '../additional/inputDatasetPath';
import tagColorsReducer from '../additional/projects/tagColors';
import tableOptionsReducer from '../additional/tableOptions/tableOptions';
import { userOrgApi } from 'store/userOrg/userOrgSlice';
import { metadataApi } from 'store/metadata/metadataSlice';
import { stagingApi } from 'store/staging/stagingSlice';
import { transferApi } from 'store/transfer/transferSlice';
import { expirioApi } from 'store/expirio/expirioSlice';
import { workflowLWDsApi } from 'store/workflowLWDs/workflowLWDsSlice';
import activeProjectsReducer from '../additional/activeProjectsSlice';
import containersReducer from '../additional/applications/containers/containersSlice';
import hpcApplicationsReducer from '../additional/applications/HPCApplications/hpcApplicationsSlice';

const reducers = combineReducers({
    menu,
    snackbar,
    [airflowApi.reducerPath]: airflowApi.reducer,
    [userOrgApi.reducerPath]: userOrgApi.reducer,
    [metadataApi.reducerPath]: metadataApi.reducer,
    [stagingApi.reducerPath]: stagingApi.reducer,
    [transferApi.reducerPath]: transferApi.reducer,
    [workflowLWDsApi.reducerPath]: workflowLWDsApi.reducer,
    [expirioApi.reducerPath]: expirioApi.reducer,

    activeProjects: activeProjectsReducer,
    jobscriptEdit: jobscriptEditSliceReducer,
    tableOptions: tableOptionsReducer,
    containers: containersReducer,
    hpcApplications: hpcApplicationsReducer,
    tagColors: tagColorsReducer,
    inputDatasetPath: inputDatasetPathReducer,
});

export default reducers;
